// removed by extract-text-webpack-plugin
module.exports = {"help-header":"help-header","help-title":"help-title","help-wrapper":"help-wrapper","help-bottom":"help-bottom","help-button-container":"help-button-container","help-button":"help-button"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/static/help/help.scss
// module id = 2750
// module chunks = 1